module.exports = __webpack_public_path__ + "media/assets/images/app/Landing/WhyUs__carousel__4-c82507c61e7da24ced6141ddcbc1dabe.jpg";